<template>
  <div class="has-text-centered">
    <h1 class="title is-3 has-text-centered mt-6" style="font-size: 70px">
      404
    </h1>
    <!--<img style="height: 400px;" :src="logo" alt="Goldmedia" />-->
    <h5 class="subtitle is-3 has-text-centered mt-2">
      Nicht gefunden
    </h5>
  </div>
</template>

<script>
// import logo from '../assets/404.jpeg';

export default {
  metaInfo: {
    title: '404',
  },
  data() {
    return {
      // isMenuActive: this.initialIsMenuActive,
      // logo,
    };
  },
};
</script>

<style>
</style>
